import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arraw",
  "use": "icon-arraw-usage",
  "viewBox": "0 0 15 10",
  "content": "<symbol viewBox=\"0 0 15 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arraw\">\n<path d=\"M0 8.5H12.5L5 1\" stroke=\"#C9CDD4\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol